export const ledgerConstants = {
  GET_LEDGER_ENTRIES_BY_ENTITY_STARTED: 'GET_LEDGER_ENTRIES_BY_ENTITY_STARTED',
  GET_LEDGER_ENTRIES_BY_ENTITY_SUCCESS: 'GET_LEDGER_ENTRIES_BY_ENTITY_SUCCESS',
  GET_LEDGER_ENTRIES_BY_ENTITY_FAILURE: 'GET_LEDGER_ENTRIES_BY_ENTITY_FAILURE',
};
